<div *ngIf="config" class="container-block">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['block-tabs']['width']"
      [height]="class['block-tabs']['min-height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- THÀNH PHẦN -->
      <li nz-submenu nzTitle="{{'thanh_phan' | translate}}" [(nzOpen)]="openMap.menu1">
        <div class="main">
          <div>
            <ng-container *ngIf="type == 'page'">
              <div class="example_btn">
                <button class="_btn d-flex justify-content-between align-items-center p-1" (click)="addTab()">
                  <span>{{'them_tab_moi' | translate}}</span>
                  <span class="ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span>
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="objectChoosing.objects.length && openMap.menu1">
              <!-- Danh sách các tabs -->
              <ul cdkDropList [style.height]="objectChoosing.objects.length <= 5 ? ' auto': '300px'"
                [style.min-height]="objectChoosing.objects.length <= 5?'auto': '300px'" class="example-list"
                (cdkDropListDropped)="cdkDropListDropped($event)">
                <li class="example-box row m-0" [class.active]="item._id == rMessage.code"
                  *ngFor="let item of objectChoosing.objects; index as i" cdkDrag>
                  <div class="col p-0 d-flex align-items-center">
                    <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
                    <!-- Hình ảnh -->
                    <img *ngIf="item?.staticdata?.content_type?.includes('image')" (click)="chooseTab(item, $event)"
                      [style.border]="item._id === tabChoosing?._id ? '1px solid #00a859' : ''" width="40" height="40"
                      [src]="item?.staticdata?.img" alt="" class="mr-1"
                      onerror="this.onerror=null;this.src='https://img.freepik.com/free-photo/green-field-tree-blue-skygreat-as-backgroundweb-banner-generative-ai_1258-153069.jpg'">
                    <!-- Chữ -->
                    <span *ngIf="item?.staticdata?.content_type?.includes('text')" class="p-0 m-0" data-toggle="tooltip"
                      [title]="(item['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component)"
                      (click)="chooseTab(item, $event)"
                      [style.font-weight]="item._id === tabChoosing?._id ? 'bold' : ''">
                      {{ (item['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' :
                      objectChoosing.component).length >= 18 ? ((item['name_' + functionService.selectedLanguageCode] |
                      vhLanguage : 'name' : objectChoosing.component) | slice:0:15) + '...' : (item['name_' +
                      functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component) }}</span>
                  </div>
                  <!-- icon 3 chấm -->
                  <div *ngIf="type == 'page'" class="colp-0">
                    <span nz-icon nzType="dash" nzTheme="outline" class="_icon_option"
                      (click)="$event.stopPropagation();onContextMenu($event, menuObjectBlockFooter)"></span>
                  </div>
                  <!-- dropdown menu sửa tên tab / xóa tab-->
                  <nz-dropdown-menu #menuObjectBlockFooter="nzDropdownMenu">
                    <ul nz-menu [nzMode]="'vertical'">
                      <!-- <li nz-menu-item class="text-success" (click)="$event.stopPropagation();editNameTab(item)">
                          <i class="bi bi-pencil-square mr-2"></i>
                          {{'sua_ten_tab' | translate}}
                        </li> -->
                      <li nz-menu-item class="text-danger" (click)="$event.stopPropagation();deleteTab(item)"><i
                          class="bi bi-trash mr-2"></i>
                        {{'xoa_tab' | translate}}</li>
                    </ul>
                  </nz-dropdown-menu>
                </li>
              </ul>
            </ng-container>

            <!-- select nội dung hoặc hình ảnh -->
            <ng-container *ngIf="tabChoosing; else noneTabChoosing">
              <div style="margin-top: 30px">
                <p class="mb-2">{{'chon_kieu_noi_dung' | translate}}</p>
                <nz-select [(ngModel)]="tabChoosing.staticdata.content_type"
                  (ngModelChange)="updateTabChoosingStaticData()"
                  nzPlaceHolder="{{'chon_noi_dung_hoac_hinh_anh' | translate}}" allowClear>
                  <nz-option [nzValue]="'text'" nzLabel="{{'chu' | translate}}"></nz-option>
                  <nz-option [nzValue]="'image'" nzLabel="{{'hinh_anh' | translate}}"></nz-option>
                  <nz-option [nzValue]="'image_and_text'" nzLabel="{{'hinh_anh_va_chu' | translate}}"></nz-option>
                  <nz-option [nzValue]="'image_and_text_and_sub'" nzLabel="{{'hinh_anh_chu_va_sub' | translate}}"></nz-option>
                  <nz-option [nzValue]="'text_and_sub'" nzLabel="{{'chu_va_sub' | translate}}"></nz-option>
                </nz-select>
              </div>
              <!-- Xuất hiện khi chọn nội dung là chữ -->
              <div *ngIf="tabChoosing?.staticdata?.content_type?.includes('text')" class="config-text"
                style="width: 100%; margin-top: 20px">
                <!-- chọn ngôn ngữ đa ngôn ngữ -->
                <mat-form-field style="width: 100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="tabChoosing['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component"
                    (ngModelChange)="tabChoosing['name_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateTabChoosingName()"></textarea>
                </mat-form-field>
                <!-- Căn lề -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'can_le' | translate}}</p>
                  </div>
                  <div class="font">
                    <button class="font-text-btn" nz-button title="flex-start" 
                      [nzType]="class['block-tabs__button-text']['text-align'] == 'left'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__button-text']['text-align'] = 'left';
                        updateClass();">
                      <i nz-icon nzType="align-left" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="center"
                      [nzType]="class['block-tabs__button-text']['text-align'] == 'center'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__button-text']['text-align'] = 'center';
                        updateClass();">
                      <i nz-icon nzType="align-center" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="flex-end"
                      [nzType]="class['block-tabs__button-text']['text-align'] == 'right'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__button-text']['text-align'] = 'right';
                        updateClass();">
                      <i nz-icon nzType="align-right" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="justify"
                      [nzType]="class['block-tabs__button-text']['text-align'] == 'justify'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__button-text']['text-align'] = 'justify';
                        updateClass();">
                      <i class="bi bi-justify"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="tabChoosing?.staticdata?.content_type?.includes('sub')" class="config-text"
                style="width: 100%; margin-top: 20px">
                <!-- chọn ngôn ngữ đa ngôn ngữ -->
                <mat-form-field style="width: 100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="tabChoosing['sub_' + functionService.selectedLanguageCode] | vhLanguage : 'sub' : objectChoosing.component"
                    (ngModelChange)="tabChoosing['sub_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateTabChoosingName('sub')"></textarea>
                </mat-form-field>
              </div>
              <!-- Xuất hiện khi chọn nội dung là hình ảnh -->
              <div class="mt-2" *ngIf="tabChoosing?.staticdata?.content_type?.includes('image')">
                <p class="mb-2">{{'hinh_anh' | translate}}</p>
                <nz-select [(ngModel)]="tabChoosing.staticdata.display" (ngModelChange)="updateTabChoosingStaticData()">
                  <nz-option [nzValue]="0" nzLabel="{{'tai_anh_len' | translate}}"></nz-option>
                  <nz-option [nzValue]="1" nzLabel="{{'chon_tu_thu_vien' | translate}}"></nz-option>
                  <nz-option [nzValue]="2" nzLabel="{{'duong_dan_hinh_anh' | translate}}"></nz-option>
                  <nz-option [nzValue]="3" nzLabel="{{'hinh_anh_mien_phi' | translate }}"></nz-option>
                </nz-select>
                <!-- Trường hợp tải ảnh từ máy -->
                <div class="mt-2" *ngIf="tabChoosing?.staticdata?.display == 0">
                  <label for="upload" class="upload-background-image">
                    <i class="bi bi-plus-circle"></i> {{'tai_anh_len' | translate}}
                  </label>
                  <input type="file" id="upload" (change)="handleUploadImg($event)" name="file" hidden />
                </div>
                <!-- Trường hợp tải ảnh từ thư viện -->
                <button class="mt-2 upload-background-image" *ngIf="tabChoosing?.staticdata?.display == 1"
                  (click)="openLibrary()">
                  <i class="bi bi-upload"></i>{{'chon_tu_thu_vien' | translate}}
                </button>

                <!-- Trường hợp chọn ảnh từ 1 đường dẫn bất kì -->
                <div class="mt-2" *ngIf="tabChoosing?.staticdata?.display == 2">
                  <textarea class="input custom-textarea w-100" name="background-image" id="background-image"
                    placeholder="{{'nhap_duong_dan_anh' | translate}}" [(ngModel)]="tabChoosing.staticdata.img"
                    (blur)="updateTabChoosingStaticData()">
                    </textarea>

                  <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ disable -->
                  <button style="width: 100%;" nz-button nzType="primary" (click)="isShowConfirmPopup = true"
                    [disabled]="tabChoosing?.staticdata?.img.includes(id_subproject)">
                    {{'chuyen_anh_len_server' | translate}}
                  </button>

                </div>
                <!-- Trường hợp chọn ảnh miễn phí -->
                <div class="mt-2" *ngIf="tabChoosing?.staticdata?.display == 3">
                  <label for="upload" (click)="openImageFree()" style="width: 100%">
                    <button class="upload-background-image">
                      <i class="bi bi-plus-circle"></i> {{'hinh_anh_mien_phi' | translate }}
                    </button>
                  </label>

                  <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ disable -->
                  <button style="width: 100%;" nz-button nzType="primary" (click)="isShowConfirmPopup = true"
                    [disabled]="tabChoosing?.staticdata?.img.includes(id_subproject)">
                    {{'chuyen_anh_len_server' | translate}}
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-template #noneTabChoosing>
              <p style="text-align: center; margin-top: 10px">
                {{'vui_long_chon_tab_truoc_khi_cau_hinh' | translate}}!!
              </p>
            </ng-template>

            <!-- Kiểu nội dung có chữ -->
            <ng-container *ngIf="tabChoosing?.staticdata?.content_type?.includes('text')">
              <hr style="border-top: 1px solid #f7ecec;">
              <p style="font-weight: 500; margin: 16px 0 8px 0;">{{'cau_hinh_tieu_de_chinh' | translate}}</p>
              <!-- MÀU NỀN -->
              <div class="config-name mb-4">
                <p>{{'mau_nen' | translate}}</p>
                <div>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="class['block-tabs__button-text']['background-color']"
                    [(colorPicker)]="class['block-tabs__button-text']['background-color']"
                    (colorPickerClose)="updateClass()" />
                </div>
              </div>
              <!-- KHOẢNG ĐỆM -->
              <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classPadding]="class['block-tabs__button-text']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
                </app-padding-config>
              </li>
              <!-- KIỂU VIỀN -->
              <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['block-tabs__button-text']" [id_object]="objectChoosing._id">
                </app-borders-config>
              </li>
              <!-- BO GÓC -->
              <li nz-submenu nzTitle="{{'bo_goc' | translate}}">
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['block-tabs__button-text']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>
              <!-- ĐỔ BÓNG -->
              <li nz-submenu nzTitle="{{'do_bong' | translate}}">
                <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['block-tabs__button-text']"
                  [shadowConfig]="config['box_text_box_shadow']" [objectChoosing]="objectChoosing">
                </app-shadow-config>
              </li>
            </ng-container>

            <!-- Kiểu nội dung là Hình ảnh hoặc Hình ảnh và chữ -->
            <ng-container *ngIf="tabChoosing?.staticdata?.content_type?.includes('image')">
              <hr style="border-top: 1px solid #f7ecec;">
              <p style="font-weight: 500; margin: 16px 0 8px 0;">{{'cau_hinh_hinh_anh' | translate}}</p>
              <!-- KÍCH THƯỚC VÀ ĐỘ BẢO PHỦ -->
              <li nz-submenu nzTitle="{{'kich_thuoc_va_do_bao_phu' | translate}}">
                <!-- chiều rộng ảnh -->
                <div>
                  <div class="config-name">
                    <span>{{'chieu_rong_anh' | translate}}</span>
                    <nz-input-number [nzMin]="1" [nzMax]="300"
                      [ngModel]="class['block-tabs__button-image']['width'] | vhnumber"
                      (ngModelChange)="class['block-tabs__button-image']['width'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="1" [nzMax]="300" [ngModel]="class['block-tabs__button-image']['width'] | vhnumber"
                    (ngModelChange)="class['block-tabs__button-image']['width'] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>

                <!-- chiều cao ảnh -->
                <div>
                  <div class="config-name">
                    <span>{{'chieu_cao_anh' | translate}}</span>
                    <nz-input-number [nzMin]="1" [nzMax]="300"
                      [ngModel]="class['block-tabs__button-image']['height'] | vhnumber"
                      (ngModelChange)="class['block-tabs__button-image']['height'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="1" [nzMax]="300" [ngModel]="class['block-tabs__button-image']['height'] | vhnumber"
                    (ngModelChange)="class['block-tabs__button-image']['height'] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>

                <hr style="border-top: 1px solid #f7ecec;">
                <p style="font-weight: 500; margin: 16px 0 8px 0;">{{'cau_hinh_bao_phu' | translate}}</p>
                <app-object-fit-config  [device]="device" [class]="class" [objectFitClass]="class['block-tabs__button-image']"
                  [style_field]="stylesField[5]" (isViewAll)="openViewAll($event)" [objectChoosing]="objectChoosing">
                </app-object-fit-config>
              </li>
              <!-- KIỂU VIỀN -->
              <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['block-tabs__button-image']" [id_object]="objectChoosing._id">
                </app-borders-config>
              </li>
              <!-- BO GÓC -->
              <li nz-submenu nzTitle="{{'bo_goc' | translate}}">
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['block-tabs__button-image']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>
              <!-- ĐỔ BÓNG -->
              <li nz-submenu nzTitle="{{'do_bong' | translate}}">
                <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['block-tabs__button-image']"
                  [shadowConfig]="config['image_box_shadow']" [objectChoosing]="objectChoosing">
                </app-shadow-config>
              </li>
            </ng-container>

            <!-- Kiểu nội dung là Hình ảnh và chữ -->
            <ng-container *ngIf="tabChoosing?.staticdata?.content_type == 'image_and_text'">
              <!-- Vị trí tiêu đề chính linh hoạt -->
              <div class="config-name">
                <p>{{'vi_tri_tieu_de_chinh_linh_hoat' | translate}}</p>
                <nz-switch [ngModel]="config['is_text_flexible']"
                  (ngModelChange)="toggleTextFlexible($event)">
                </nz-switch>
              </div>

              <!-- Vị trí top/left -->
              <ng-container *ngIf="config.is_text_flexible">
                <!-- Vị trí dọc -->
                <div>
                  <div class="config-name">
                    <span>{{'vi_tri_doc' | translate}}</span>
                    <nz-input-number [nzMin]="0" [nzMax]="250"
                      [ngModel]="class['block-tabs__button-text']['top'] | vhnumber" 
                      (ngModelChange)="class['block-tabs__button-text']['top'] = $event + '%'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="250"
                    [ngModel]="class['block-tabs__button-text']['top'] | vhnumber" 
                    (ngModelChange)="class['block-tabs__button-text']['top'] = $event + '%'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Vị trí ngang -->
                <div>
                  <div class="config-name">
                    <span>{{'vi_tri_ngang' | translate}}</span>
                    <nz-input-number [nzMin]="0" [nzMax]="250"
                      [ngModel]="class['block-tabs__button-text']['left'] | vhnumber" 
                      (ngModelChange)="class['block-tabs__button-text']['left'] = $event + '%'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="250"
                    [ngModel]="class['block-tabs__button-text']['left'] | vhnumber" 
                    (ngModelChange)="class['block-tabs__button-text']['left'] = $event + '%'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </ng-container>

              <ng-container *ngIf="!config.is_text_flexible">
                <!-- Khoảng cách giữa hình ảnh và chữ -->
                <div>
                  <div class="config-name">
                    <span>{{'khoang_cach_giua_hinh_anh_va_chu' | translate}}</span>
                    <nz-input-number [nzMin]="0" [nzMax]="250"
                      [ngModel]="class['block-tabs__button-title']['gap'] | vhnumber" 
                      (ngModelChange)="class['block-tabs__button-title']['gap'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="250"
                    [ngModel]="class['block-tabs__button-title']['gap'] | vhnumber" 
                    (ngModelChange)="class['block-tabs__button-title']['gap'] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Thay đổi vị trí  -->
                <div class="mt-4">
                  <p>{{'thay_doi_vi_tri' | translate}}</p>
                  <nz-radio-group [(ngModel)]="class['block-tabs__button-title']['flex-direction']"
                    (ngModelChange)="updateClass()">
                    <label nz-radio nzValue="column">{{ 'anh_nam_tren_chu' | translate}}</label>
                    <label nz-radio nzValue="column-reverse">{{ 'anh_nam_duoi_chu' | translate}}</label>
                    <label nz-radio nzValue="row">{{ 'anh_truoc_chu_sau' | translate}}</label>
                    <label nz-radio nzValue="row-reverse">{{ 'chu_truoc_anh_sau' | translate}}</label>
                  </nz-radio-group>
                </div>
              </ng-container>
            </ng-container>

            <!-- Kiểu nội dung có sub -->
            <ng-container *ngIf="tabChoosing?.staticdata?.content_type?.includes('sub')">
              <!-- Khoảng cách giữa nội dung và sub -->
              <div>
                <div class="config-name">
                  <span>{{'khoang_cach_giua_noi_dung_va_sub' | translate}}</span>
                  <nz-input-number [nzMin]="0" [nzMax]="250"
                    [ngModel]="class['block-tabs__container--button-active']['gap'] | vhnumber" (ngModelChange)="
                      class['block-tabs__container--button-active']['gap'] = $event + 'px';
                      class['block-tabs__container--button-inactive']['gap'] = $event + 'px';"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="250"
                  [ngModel]="class['block-tabs__container--button-active']['gap'] | vhnumber" (ngModelChange)="
                      class['block-tabs__container--button-active']['gap'] = $event + 'px';
                      class['block-tabs__container--button-inactive']['gap'] = $event + 'px';"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </ng-container>

            <!-- chiều cao nút -->
            <div class="font-adjusting mt-4">
              <div class="row-spacing">
                <span class="title">{{'chieu_cao_nut' | translate}}</span>
                <nz-input-number [nzMin]="0" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['block-tabs__container--button-inactive']['min-height'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['block-tabs__container--button-inactive']['min-height'] = $event + 'px';
                      class['block-tabs__container--button-active']['min-height'] = $event + 'px'
                    "></nz-input-number>
              </div>
              <nz-slider [nzMin]="0"
                [ngModel]="class['block-tabs__container--button-inactive']['min-height'] | vhnumber"
                (nzOnAfterChange)="updateClass()" (ngModelChange)="
                    class['block-tabs__container--button-inactive']['min-height'] = $event + 'px';
                    class['block-tabs__container--button-active']['min-height'] = $event + 'px'
                  "></nz-slider>
            </div>
            <!-- chiều rộng nút -->
            <div class="font-adjusting mt-2">
              <div class="row-spacing">
                <span class="title">{{'chieu_rong_nut' | translate}}</span>
                <nz-input-number [nzMin]="0" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['block-tabs__container--button-inactive']['min-width'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['block-tabs__container--button-inactive']['min-width'] = $event + 'px';
                      class['block-tabs__container--button-active']['min-width'] = $event + 'px'
                    "></nz-input-number>
              </div>
              <nz-slider [nzMin]="0"
                [ngModel]="class['block-tabs__container--button-inactive']['min-width'] | vhnumber"
                (nzOnAfterChange)="updateClass()" (ngModelChange)="
                    class['block-tabs__container--button-inactive']['min-width'] = $event + 'px';
                    class['block-tabs__container--button-active']['min-width'] = $event + 'px'
                  "></nz-slider>
            </div>
            <!-- Khoảng cách giữa các nút -->
            <div>
              <div class="config-name">
                <p>{{'khoang_cach_giua_cac_nut' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" style="width: 100px" [ngModel]="
                  class['block-tabs__container--button']['gap'] | vhnumber
                " (ngModelChange)="
                  class['block-tabs__container--button']['gap'] = $event + 'px'
                " (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" style="width: 70%"
                [ngModel]="class['block-tabs__container--button']['gap'] | vhnumber" (ngModelChange)="
                class['block-tabs__container--button']['gap'] = $event + 'px'
              " (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </div>
        </div>
      </li>
      <!-- THIẾT LẬP CỤM TIÊU ĐỀ -->
      <li nz-submenu nzTitle="{{'thiet_lap_cum_tieu_de' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <!-- Tự động giãn đều -->
        <div class="config-name">
          <p>{{'gian_deu_kich_thuoc' | translate}}</p>
          <nz-switch [(ngModel)]="config['isTitleAutoResize']"
            (ngModelChange)="handleTitleAutoResize()">
          </nz-switch>
        </div>
        <div class="config-name">
          <span class="title">{{'do_dai_toi_da' | translate}}:</span>
          <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '40%' }" 
            [(ngModel)]="config['tab_aspect_ratio']" (nzBlur)="handleTitleAutoResize()">
          </nz-input-number>
        </div>
        <!-- Vị trí -->
        <div class="mt-4">
          <p>{{'vi_tri' | translate}}</p>
          <div class="config-name" style="gap: 0px">
            <!-- Trên -->
            <button nz-button class="font-text-btn flex border border-right-0"
              [nzType]="class['block-tabs']['flex-direction'] == 'column' ? 'primary' : 'default'"
              (click)="updateTabPosition('top', config['tab_align'])">
              <span class="item__sidebar--text">{{'tren' | translate}}</span>
            </button>

            <!-- Dưới -->
            <button nz-button class="font-text-btn flex border border-right-0"
              [nzType]="class['block-tabs']['flex-direction'] == 'column-reverse' ? 'primary' : 'default'"
              (click)="updateTabPosition('bottom', config['tab_align'])">
              <span class="item__sidebar--text">{{'duoi' | translate}}</span>
            </button>

            <!-- Trái -->
            <button nz-button class="font-text-btn flex border border-right-0"
              [nzType]="class['block-tabs']['flex-direction'] == 'row' ? 'primary' : 'default'"
              (click)="updateTabPosition('left', config['tab_align'])">
              <span class="item__sidebar--text">{{'trai' | translate}}</span>
            </button>

            <!-- Phải -->
            <button nz-button class="font-text-btn flex border border-right-0"
              [nzType]="class['block-tabs']['flex-direction'] == 'row-reverse' ? 'primary' : 'default'"
              (click)="updateTabPosition('right', config['tab_align'])">
              <span class="item__sidebar--text">{{'phai' | translate}}</span>
            </button>
          </div>
        </div>
        <div *ngIf="!isTabOverflowing" class="config-name" style="gap: 0px">
          <button nz-button class="font-text-btn flex border border-right-0"
            [nzType]="class['block-tabs__container']['justify-content'] =='flex-start' ? 'primary' : 'default'"
            (click)="updateTabPosition(config['tab_position'], 'left')">
            <span *ngIf="config['tab_position']=='top' || config['tab_position']=='bottom'" class="item__sidebar--text">{{'trai' | translate}}</span>
            <span *ngIf="config['tab_position']=='left' || config['tab_position']=='right'" class="item__sidebar--text">{{'tren' | translate}}</span>
          </button>
          <button nz-button class="font-text-btn flex border border-right-0"
            [nzType]=" class['block-tabs__container']['justify-content'] == 'center' ? 'primary' : 'default' "
            (click)=" updateTabPosition(config['tab_position'], 'center')">
            <span class="item__sidebar--text">{{'giua' | translate}}</span>
          </button>
          <button nz-button class="font-text-btn flex border"
            [nzType]="class['block-tabs__container']['justify-content'] =='flex-end'? 'primary': 'default'"
            (click)="updateTabPosition(config['tab_position'], 'right')">
            <span *ngIf="config['tab_position']=='top' || config['tab_position']=='bottom'" class="item__sidebar--text">{{'phai' | translate}}</span>
            <span *ngIf="config['tab_position']=='left' || config['tab_position']=='right'" class="item__sidebar--text">{{'duoi' | translate}}</span>
          </button>
        </div>
        <!-- Tự động giãn đều -->
        <div class="config-name">
          <p>{{(['top', 'bottom'].includes(config['tab_position']) ? 'nhieu_cot' : 'nhieu_hang') | translate}}</p>
          <nz-switch [ngModel]="config.is_group_button_wrap"
            (ngModelChange)="config.is_group_button_wrap = $event; handleGroupButtonWrap($event)">
          </nz-switch>
        </div>
        <ng-container *ngIf="config.is_group_button_wrap">
          <!-- Độ rộng cụm tiêu đề -->
          <div *ngIf="config['tab_position'] == 'left' || config['tab_position'] == 'right'">
            <div class="config-name">
              <p>{{'do_rong_cum_tieu_de' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="500"
                [ngModel]="class['block-tabs__container--button'].width | vhnumber"
                (ngModelChange)="class['block-tabs__container--button'].width = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="500" [nzStep]="10"
                [ngModel]="class['block-tabs__container--button'].width | vhnumber"
                (ngModelChange)="class['block-tabs__container--button'].width = $event + 'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </div>
          <!-- Độ rộng cụm tiêu đề -->
          <div *ngIf="config['tab_position'] == 'top' || config['tab_position'] == 'bottom'">
            <div class="config-name">
              <p>{{'do_cao_cum_tieu_de' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="500"
                [ngModel]="class['block-tabs__container--button'].height | vhnumber"
                (ngModelChange)="class['block-tabs__container--button'].height = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="500" [nzStep]="10"
                [ngModel]="class['block-tabs__container--button'].width | vhnumber"
                (ngModelChange)="class['block-tabs__container--button'].height = $event + 'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </div>
        </ng-container>
      </li>
      <!-- CUỘN CỤM TIÊU ĐỀ -->
      <li nz-submenu nzTitle="{{'cuon_cum_tieu_de' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <!-- Cuộn khi chọn tab hoặc bấm nút điều hướng tự scroll đến -->
        <div class="mt-2">
          <p>{{'cuon_den_tab' | translate}}</p>
          <div class="config-name" style="gap: 0px">
            <button nz-button class="font-text-btn flex border border-right-0"
              [nzType]="config['scroll_active_tab'] == 'start' ? 'primary' : 'default'"
              (click)="config['scroll_active_tab'] = 'start';updateConfig()">
              <span *ngIf="config['tab_position']=='top' || config['tab_position']=='bottom'" class="item__sidebar--text">{{'trai' | translate}}</span>
              <span *ngIf="config['tab_position']=='left' || config['tab_position']=='right'" class="item__sidebar--text">{{'tren' | translate}}</span>
            </button>
            <button nz-button class="font-text-btn flex border border-right-0"
              [nzType]=" config['scroll_active_tab'] == 'center' ? 'primary' : 'default' "
              (click)="config['scroll_active_tab'] = 'center';updateConfig()">
              <span class="item__sidebar--text">{{'giua' | translate}}</span>
            </button>
            <button nz-button class="font-text-btn flex border"
              [nzType]="config['scroll_active_tab'] == 'end'? 'primary': 'default'"
              (click)="config['scroll_active_tab'] = 'end';updateConfig()">
              <span *ngIf="config['tab_position']=='top' || config['tab_position']=='bottom'" class="item__sidebar--text">{{'phai' | translate}}</span>
              <span *ngIf="config['tab_position']=='left' || config['tab_position']=='right'" class="item__sidebar--text">{{'duoi' | translate}}</span>
            </button>
          </div>
        </div>
        <!-- Bật tắt thanh cuộn -->
        <div class="config-name mt-4">
          <p>{{(config?.['-webkit-scrollbar']?.['display'] == 'block' ? 'tat_thanh_cuon' : 'bat_thanh_cuon') | translate}}</p>
          <nz-switch [ngModel]="config?.['-webkit-scrollbar']?.['display'] == 'block'" 
          (ngModelChange)="toggleShowScrollbar($event)">
          </nz-switch>
        </div> 
        <!-- Cấu hình thanh cuộn -->
        <ng-container *ngIf="config?.['-webkit-scrollbar']?.['display'] == 'block'">
          <!-- Độ rộng thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'do_rong_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Độ cao thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'do_cao_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['height'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['height'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['height'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['height'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Bo góc thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'bo_goc_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['thumb-border-radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['thumb-border-radius'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['thumb-border-radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['thumb-border-radius'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Màu nền thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_nen_thanh_cuon' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['background-color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Màu thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_thanh_keo' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['thumb-background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['thumb-background-color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Màu di chuột thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_di_chuot_thanh_keo' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['thumb-hover-background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['thumb-hover-background-color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
        </ng-container>
      </li>
      <!-- THIẾT LẬP TAB ĐƯỢC CHỌN -->
      <li nz-submenu nzTitle="{{'thiet_lap_tab_duoc_chon' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="main">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <div class="color-pick">
              <input class="input-color" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['block-tabs__container--button-active']['background-color']"
              [style.background]="class['block-tabs__container--button-active']['background-color']"
              (colorPickerClose)="updateClass()" [disabled]="config['active-background-color']?.gradient_check" />
            </div>
          </div>
          <p class="discover_text" (click)="openViewAll(stylesField[6])"
            style="cursor: pointer; text-align: right; margin: 0; line-height: 1.5;">
            {{'mau_gradient' | translate}} &#8594;
          </p>
          <!-- Định dạng tiêu đề chính -->
          <li *ngIf="tabChoosing?.staticdata?.content_type?.includes('text')" nz-submenu nzTitle="{{'dinh_dang_tieu_de_chinh' | translate}}">
            <div class="config-name">
              <!-- Font Family -->
              <div class="field-row-font" style="width: 65%">
                <mat-form-field style="width: 100%">
                  <mat-label>Font</mat-label>
                  <mat-select [(ngModel)]="
                      class['block-tabs__container--button-active']['font-family']
                    " (ngModelChange)="updateClass()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                      font.name
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Font size -->
              <div class="field-row-size" style="width: 35%; padding-right: 5px">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                  <input matInput type="number" [min]="1" [max]="200" [ngModel]="
                      class['block-tabs__container--button-active']['font-size']
                        | vhnumber
                    " (ngModelChange)="
                      class['block-tabs__container--button-active']['font-size'] =
                        $event + 'px'
                    " (blur)="updateClass()" />
                </mat-form-field>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="config-name">
                  <!-- In đậm -->
                  <button class="font-text-btn" title="Bold" nz-button [nzType]="
                      class['block-tabs__container--button-active'][
                        'font-weight'
                      ] >= 700
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-active'][
                        'font-weight'
                      ] =
                        class['block-tabs__container--button-active'][
                          'font-weight'
                        ] >= 700
                          ? '400'
                          : '700'
                    " (click)="updateClass()">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class['block-tabs__container--button-active'][
                        'font-style'
                      ] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-active'][
                        'font-style'
                      ] =
                        class['block-tabs__container--button-active'][
                          'font-style'
                        ] == 'normal'
                          ? 'italic'
                          : 'normal'
                    " (click)="updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class['block-tabs__container--button-active'][
                        'text-decoration'
                      ] == 'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-active'][
                        'text-decoration'
                      ] =
                        class['block-tabs__container--button-active'][
                          'text-decoration'
                        ] == 'none'
                          ? 'underline'
                          : 'none'
                    " (click)="updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class['block-tabs__container--button-active'][
                        'text-transform'
                      ] == 'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-active'][
                        'text-transform'
                      ] =
                        class['block-tabs__container--button-active'][
                          'text-transform'
                        ] == 'none'
                          ? 'uppercase'
                          : 'none'
                    " (click)="updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <input class="input-color" style="width: 17%" [style.background]="
                      class['block-tabs__container--button-active']['color']
                    " [cpOKButton]="true" [(colorPicker)]="
                      class['block-tabs__container--button-active']['color']
                    " (colorPickerClose)="updateClass()" type="button" />
                </div>
                <!-- Căn lề -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'can_le' | translate}}</p>
                  </div>
                  <div class="font">
                    <button class="font-text-btn" nz-button title="flex-start" 
                      [nzType]="class['block-tabs__container--button-active']['align-items'] == 'flex-start'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__container--button-active']['align-items'] = 'flex-start';
                        updateClass();">
                      <i nz-icon nzType="align-left" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="center"
                      [nzType]="class['block-tabs__container--button-active']['align-items'] == 'center'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__container--button-active']['align-items'] = 'center';
                        updateClass();">
                      <i nz-icon nzType="align-center" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="flex-end"
                      [nzType]="class['block-tabs__container--button-active']['align-items'] == 'flex-end'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__container--button-active']['align-items'] = 'flex-end';
                        updateClass();">
                      <i nz-icon nzType="align-right" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
                <!-- Độ đậm -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'do_dam' | translate}}</p>
                    <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                        class['block-tabs__container--button-active'][
                          'font-weight'
                        ]
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                          class['block-tabs__container--button-active'][
                            'font-weight'
                          ]
                        " (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </li>
          <!-- Định dạng tiêu đề phụ -->
          <li *ngIf="tabChoosing?.staticdata?.content_type?.includes('sub')" nz-submenu nzTitle="{{'dinh_dang_sub' | translate}}">
            <div class="config-name">
              <!-- Font Family -->
              <div class="field-row-font" style="width: 65%">
                <mat-form-field style="width: 100%">
                  <mat-label>Font</mat-label>
                  <mat-select [(ngModel)]="
                      class['block-tabs__button-sub-active']['font-family']
                    " (ngModelChange)="updateClass()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                      font.name
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Font size -->
              <div class="field-row-size" style="width: 35%; padding-right: 5px">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                  <input matInput type="number" [min]="1" [max]="200" [ngModel]="
                      class['block-tabs__button-sub-active']['font-size']
                        | vhnumber
                    " (ngModelChange)="
                      class['block-tabs__button-sub-active']['font-size'] =
                        $event + 'px'
                    " (blur)="updateClass()" />
                </mat-form-field>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="config-name">
                  <!-- In đậm -->
                  <button class="font-text-btn" title="Bold" nz-button [nzType]="
                      class['block-tabs__button-sub-active'][
                        'font-weight'
                      ] >= 700
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-active'][
                        'font-weight'
                      ] =
                        class['block-tabs__button-sub-active'][
                          'font-weight'
                        ] >= 700
                          ? '400'
                          : '700'
                    " (click)="updateClass()">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class['block-tabs__button-sub-active'][
                        'font-style'
                      ] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-active'][
                        'font-style'
                      ] =
                        class['block-tabs__button-sub-active'][
                          'font-style'
                        ] == 'normal'
                          ? 'italic'
                          : 'normal'
                    " (click)="updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class['block-tabs__button-sub-active'][
                        'text-decoration'
                      ] == 'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-active'][
                        'text-decoration'
                      ] =
                        class['block-tabs__button-sub-active'][
                          'text-decoration'
                        ] == 'none'
                          ? 'underline'
                          : 'none'
                    " (click)="updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class['block-tabs__button-sub-active'][
                        'text-transform'
                      ] == 'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-active'][
                        'text-transform'
                      ] =
                        class['block-tabs__button-sub-active'][
                          'text-transform'
                        ] == 'none'
                          ? 'uppercase'
                          : 'none'
                    " (click)="updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <input class="input-color" style="width: 17%" [style.background]="
                      class['block-tabs__button-sub-active']['color']
                    " [cpOKButton]="true" [(colorPicker)]="
                      class['block-tabs__button-sub-active']['color']
                    " (colorPickerClose)="updateClass()" type="button" />
                </div>
                <!-- Độ đậm -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'do_dam' | translate}}</p>
                    <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                        class['block-tabs__button-sub-active'][
                          'font-weight'
                        ]
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                          class['block-tabs__button-sub-active'][
                            'font-weight'
                          ]
                        " (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </li>
          <!-- Kiểu viền -->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['block-tabs__container--button-active']" [id_object]="objectChoosing._id">
            </app-borders-config>

            <p class="discover_text" (click)="openViewAll(stylesField[0])"
              style="cursor: pointer; text-align: right; margin: 0; line-height: 1.5;">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </li>
          <!-- Khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['block-tabs__container--button-active']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
            </app-padding-config>
          </li>
          <!-- Đổ bóng -->
          <li nz-submenu nzTitle="{{'do_bong' | translate}}">
            <app-shadow-config 
              [device]="device"
              [config]="config"
              [class]="class"
              [shadowClass]="class['block-tabs__container--button-active']"
              [shadowConfig]="config['block-tabs__container--button-active_shadow']"
              [objectChoosing]="objectChoosing"
              >
            </app-shadow-config>
          </li>
        </div>
      </li>
      <!-- THIẾT LẬP TAB CHƯA CHỌN -->
      <li nz-submenu nzTitle="{{'thiet_lap_tab_chua_chon' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <div class="main">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" type="button"
              [(colorPicker)]="class['block-tabs__container--button-inactive']['background-color']"
              [style.background]="class['block-tabs__container--button-inactive']['background-color']"
              (colorPickerClose)="updateClass()" [disabled]="config['inactive-background-color']?.gradient_check" />
            </div>
          </div>
          <p class="discover_text" (click)="openViewAll(stylesField[7])"
            style="cursor: pointer; text-align: right; margin: 0; line-height: 1.5;">
            {{'mau_gradient' | translate}} &#8594;
          </p>
          <!-- Định dạng tiêu đề chính -->
          <li *ngIf="tabChoosing?.staticdata?.content_type?.includes('text')" nz-submenu nzTitle="{{'dinh_dang_tieu_de_chinh' | translate}}">
            <div class="config-name">
              <!-- Font Family -->
              <div class="field-row-font" style="width: 65%">
                <mat-form-field style="width: 100%">
                  <mat-label>Font</mat-label>
                  <mat-select [(ngModel)]="
                      class['block-tabs__container--button-inactive'][
                        'font-family'
                      ]
                    " (ngModelChange)="updateClass()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                      font.name
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Font size -->
              <div class="field-row-size" style="width: 35%; padding-right: 5px">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                  <input matInput type="number" [min]="1" [max]="200" [ngModel]="
                      class['block-tabs__container--button-inactive']['font-size']
                        | vhnumber
                    " (ngModelChange)="
                      class['block-tabs__container--button-inactive'][
                        'font-size'
                      ] = $event + 'px'
                    " (blur)="updateClass()" />
                </mat-form-field>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="config-name">
                  <!-- In đậm -->
                  <button class="font-text-btn" title="Bold" nz-button [nzType]="
                      class['block-tabs__container--button-inactive'][
                        'font-weight'
                      ] >= 700
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-inactive'][
                        'font-weight'
                      ] =
                        class['block-tabs__container--button-inactive'][
                          'font-weight'
                        ] >= 700
                          ? '400'
                          : '700'
                    " (click)="updateClass()">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class['block-tabs__container--button-inactive'][
                        'font-style'
                      ] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-inactive'][
                        'font-style'
                      ] =
                        class['block-tabs__container--button-inactive'][
                          'font-style'
                        ] == 'normal'
                          ? 'italic'
                          : 'normal'
                    " (click)="updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class['block-tabs__container--button-inactive'][
                        'text-decoration'
                      ] == 'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-inactive'][
                        'text-decoration'
                      ] =
                        class['block-tabs__container--button-inactive'][
                          'text-decoration'
                        ] == 'none'
                          ? 'underline'
                          : 'none'
                    " (click)="updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class['block-tabs__container--button-inactive'][
                        'text-transform'
                      ] == 'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__container--button-inactive'][
                        'text-transform'
                      ] =
                        class['block-tabs__container--button-inactive'][
                          'text-transform'
                        ] == 'none'
                          ? 'uppercase'
                          : 'none'
                    " (click)="updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <input class="input-color" style="width: 17%" [style.background]="
                      class['block-tabs__container--button-inactive']['color']
                    " [cpOKButton]="true" [(colorPicker)]="
                      class['block-tabs__container--button-inactive']['color']
                    " (colorPickerClose)="updateClass()" type="button" />
                </div>
                <!-- Căn lề -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'can_le' | translate}}</p>
                  </div>
                  <div class="font">
                    <button class="font-text-btn" nz-button title="flex-start" 
                      [nzType]="class['block-tabs__container--button-inactive']['align-items'] == 'flex-start'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__container--button-inactive']['align-items'] = 'flex-start';
                        updateClass();">
                      <i nz-icon nzType="align-left" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="center"
                      [nzType]="class['block-tabs__container--button-inactive']['align-items'] == 'center'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__container--button-inactive']['align-items'] = 'center';
                        updateClass();">
                      <i nz-icon nzType="align-center" nzTheme="outline"></i>
                    </button>
                    <button class="font-text-btn" nz-button title="flex-end"
                      [nzType]="class['block-tabs__container--button-inactive']['align-items'] == 'flex-end'
                        ? 'primary'
                        : 'default'" 
                      (click)="
                        class['block-tabs__container--button-inactive']['align-items'] = 'flex-end';
                        updateClass();">
                      <i nz-icon nzType="align-right" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
                <!-- Độ đậm -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'do_dam' | translate}}</p>
                    <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                        class['block-tabs__container--button-inactive'][
                          'font-weight'
                        ]
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                          class['block-tabs__container--button-inactive'][
                            'font-weight'
                          ]
                        " (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </li>
          <!-- Định dạng tiêu đề phụ -->
          <li *ngIf="tabChoosing?.staticdata?.content_type?.includes('sub')" nz-submenu nzTitle="{{'dinh_dang_sub' | translate}}">
            <div class="config-name">
              <!-- Font Family -->
              <div class="field-row-font" style="width: 65%">
                <mat-form-field style="width: 100%">
                  <mat-label>Font</mat-label>
                  <mat-select [(ngModel)]="
                      class['block-tabs__button-sub-inactive']['font-family']
                    " (ngModelChange)="updateClass()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                      font.name
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Font size -->
              <div class="field-row-size" style="width: 35%; padding-right: 5px">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                  <input matInput type="number" [min]="1" [max]="200" [ngModel]="
                      class['block-tabs__button-sub-inactive']['font-size']
                        | vhnumber
                    " (ngModelChange)="
                      class['block-tabs__button-sub-inactive']['font-size'] =
                        $event + 'px'
                    " (blur)="updateClass()" />
                </mat-form-field>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="config-name">
                  <!-- In đậm -->
                  <button class="font-text-btn" title="Bold" nz-button [nzType]="
                      class['block-tabs__button-sub-inactive'][
                        'font-weight'
                      ] >= 700
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-inactive'][
                        'font-weight'
                      ] =
                        class['block-tabs__button-sub-inactive'][
                          'font-weight'
                        ] >= 700
                          ? '400'
                          : '700'
                    " (click)="updateClass()">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class['block-tabs__button-sub-inactive'][
                        'font-style'
                      ] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-inactive'][
                        'font-style'
                      ] =
                        class['block-tabs__button-sub-inactive'][
                          'font-style'
                        ] == 'normal'
                          ? 'italic'
                          : 'normal'
                    " (click)="updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class['block-tabs__button-sub-inactive'][
                        'text-decoration'
                      ] == 'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-inactive'][
                        'text-decoration'
                      ] =
                        class['block-tabs__button-sub-inactive'][
                          'text-decoration'
                        ] == 'none'
                          ? 'underline'
                          : 'none'
                    " (click)="updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class['block-tabs__button-sub-inactive'][
                        'text-transform'
                      ] == 'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['block-tabs__button-sub-inactive'][
                        'text-transform'
                      ] =
                        class['block-tabs__button-sub-inactive'][
                          'text-transform'
                        ] == 'none'
                          ? 'uppercase'
                          : 'none'
                    " (click)="updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <input class="input-color" style="width: 17%" [style.background]="
                      class['block-tabs__button-sub-inactive']['color']
                    " [cpOKButton]="true" [(colorPicker)]="
                      class['block-tabs__button-sub-inactive']['color']
                    " (colorPickerClose)="updateClass()" type="button" />
                </div>
                <!-- Độ đậm -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'do_dam' | translate}}</p>
                    <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                        class['block-tabs__button-sub-inactive'][
                          'font-weight'
                        ]
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100" [(ngModel)]="
                          class['block-tabs__button-sub-inactive'][
                            'font-weight'
                          ]
                        " (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </li>
          <!-- Kiểu viền -->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['block-tabs__container--button-inactive']" [id_object]="objectChoosing._id">
            </app-borders-config>

            <p class="discover_text" (click)="openViewAll(stylesField[1])"
              style="cursor: pointer; text-align: right; margin: 0; line-height: 1.5;">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </li>
          <!-- Khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['block-tabs__container--button-inactive']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
            </app-padding-config>
          </li>
          <!-- Đổ bóng -->
          <li nz-submenu nzTitle="{{'do_bong' | translate}}">
            <app-shadow-config 
              [device]="device"
              [config]="config"
              [class]="class"
              [shadowClass]="class['block-tabs__container--button-inactive']"
              [shadowConfig]="config['block-tabs__container--button-inactive_shadow']"
              [objectChoosing]="objectChoosing"
              >
            </app-shadow-config>
          </li>
        </div>
      </li>
      <!-- THIẾT LẬP NÚT ĐIỀU HƯỚNG -->
      <li nz-submenu nzTitle="{{'thiet_lap_nut_dieu_huong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="config-name">
          <p>{{'hien_thi_nut_dieu_huong' | translate}}</p>
          <nz-switch [(ngModel)]="config['arrow']['isDisplay']"
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
        
        <div class="main" *ngIf="config['arrow']?.['isDisplay']">
          <div class="config-name">
            <div class="config-name" style="gap: 0px">
              <!-- Trên -->
              <button nz-button class="font-text-btn flex border border-right-0"
                [nzType]="config['arrow']['position'] == 'top' ? 'primary' : 'default'"
                (click)="updateArrowPosition('top')">
                <span class="item__sidebar--text">{{'tren' | translate}}</span>
              </button>
  
              <!-- Dưới -->
              <button nz-button class="font-text-btn flex border border-right-0"
                [nzType]="config['arrow']['position'] == 'bottom' ? 'primary' : 'default'"
                (click)="updateArrowPosition('bottom')">
                <span class="item__sidebar--text">{{'duoi' | translate}}</span>
              </button>
  
              <!-- Trái -->
              <button nz-button class="font-text-btn flex border border-right-0"
                [nzType]="config['arrow']['position'] == 'left' ? 'primary' : 'default'"
                (click)="updateArrowPosition('left')">
                <span class="item__sidebar--text">{{'trai' | translate}}</span>
              </button>
  
              <!-- Phải -->
              <button nz-button class="font-text-btn flex border border-right-0"
                [nzType]="config['arrow']['position'] == 'right' ? 'primary' : 'default'"
                (click)="updateArrowPosition('right')">
                <span class="item__sidebar--text">{{'phai' | translate}}</span>
              </button>
            </div>
          </div>
          <div class="config-name">
            <span class="title">{{'khoang_cach_2_nut' | translate}}:</span>
            <nz-input-number [nzMin]="0" [ngStyle]="{ width: '30%' }" 
              [(ngModel)]="config['arrow']['distance']" (nzBlur)="updateArrow()">
            </nz-input-number>
          </div>
          <div class="config-name">
            <span class="title">{{'kich_thuoc' | translate}} Icon:</span>
            <nz-input-number [nzMin]="0" [ngStyle]="{ width: '30%' }" 
              [(ngModel)]="config['arrow']['size']" (nzBlur)="updateArrow()">
            </nz-input-number>
          </div>
          <div class="config-name mt-0">
            <p>{{'mau_icon' | translate}}</p>
            <div class="color-pick">
              <input class="input-color" type="button" [cpOKButton]="true" 
                [(colorPicker)]="class['block-tabs__container--arrow']['color']" 
                [style.background]="class['block-tabs__container--arrow']['color']" 
                (colorPickerClose)="updateClass()" 
              />
            </div>
          </div>
        </div>
        
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung'| translate}}" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <app-choose-animations-config  [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'frame-tabs'"
          [cursorClass]="class['block-tabs__container--button-active']" [cursorClass2]="class['block-tabs__container--button-inactive']"
          [titleCursor]="{ cursor1: 'con_tro_cua_tab_duoc_chon', cursor2: 'con_tro_cua_tab_chua_chon' }">
        </app-choose-animations-config>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['block-tabs__container--button-active']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['block-tabs__container--button-inactive']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 5">
      <app-animations-config [elementChoosing]="objectChoosing"  [device]="device" [staticdata]="staticdata"
        [id_object]="objectChoosing._id"[customize]="customize">
      </app-animations-config>
    </div>
    <!-- Mở rộng cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 6">
      <div class="field-row">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'vi_tri_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'ngang'| translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_x" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'doc'| translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_y" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>
      </div>
      <div class="field-row mt-2">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'phong_thu_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'do_co_gian'| translate}}</p>
        </div>
        <nz-slider [ngModel]="class['block-tabs__button-image'].transfrom_scale" (nzOnAfterChange)="scale()"
          (ngModelChange)="class['block-tabs__button-image'].transfrom_scale = $event" [nzMin]="0.1" [nzMax]="2"
          [nzStep]="0.1"></nz-slider>
      </div>
    </div>
    <!-- Cấu hình chi tiết màu gradient -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 7 || currentViewAll.index == 8">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox
        [ngModel]="config[getGradientBg + '-background-color']?.gradient_check"
        (ngModelChange)="
          config[getGradientBg + '-background-color'].gradient_check = $event;
          updateBackgroundRgb()
        "></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
            let bgGradient of config[getGradientBg + '-background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config[getGradientBg + '-background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" type="button"
        [(colorPicker)]="config[getGradientBg + '-background-color'].background"
        [disabled]="!config[getGradientBg + '-background-color'].gradient_check"
        [style.background]="config[getGradientBg + '-background-color'].background"
        (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
        nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
        [disabled]="!config[getGradientBg + '-background-color'].gradient_check"
        [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config[getGradientBg + '-background-color'].gradient_direction === type.direction">
      </button>
    </div>
  </div>

  <nz-modal nzTitle="{{ 'thong_bao' | translate}}" [(nzVisible)]="isShowConfirmPopup" [nzContent]="modalContent"
    (nzOnCancel)="handleCancelConfirm()" (nzOnOk)="handleOkConfirm()" [nzFooter]="modalFooter">
    <ng-template #modalContent>
      <p>{{"ban_co_muon_chuyen_anh_len_server_khong" | translate}}?</p>
    </ng-template>
    <ng-template #modalFooter>
      <button nz-button nzType="default" (click)="handleCancelConfirm()">{{'khong' | translate}}</button>
      <button nz-button nzType="primary" (click)="handleOkConfirm()" [nzLoading]="isConfirmLoading">{{'dong_y' |
        translate}}</button>
    </ng-template>
  </nz-modal>
</div>